<template>
    <div>
        <myHead/>
        <a-spin :spinning="isLoading" tip="加载中...">
        <div style="padding:20px">
            
            <a-card  style="width: 100%;" >
                <a-row style="text-align:center;margin-left:-24px;margin-right:-24px">
                    <a-col :span="4" style="border-right:rgba(0, 0, 0, 0.06) 1px solid">
                        <div class="miaoshu">
                            任务数量
                        </div>
                        <div class="neirong">
                            {{task.TaskNum}}
                        </div>
                    </a-col>
                    <a-col :span="4" style="border-right:rgba(0, 0, 0, 0.06) 1px solid">
                        <div class="miaoshu" >
                            总单数
                        </div>
                        <div style="margin-top:25px">
                                <a-tag color="#409EFF">{{task.Total}}</a-tag>
                        </div>
                    </a-col>
                    <a-col :span="4" style="border-right:rgba(0, 0, 0, 0.06) 1px solid">
                        <div class="miaoshu" >
                            待调度
                        </div>
                        <div style="margin-top:25px">
                                <a-tag color="#E6A23C">{{task.Wait}}</a-tag>
                        </div>
                    </a-col>
                    <a-col :span="4" style="border-right:rgba(0, 0, 0, 0.06) 1px solid">
                        <div class="miaoshu" >
                            进行中
                        </div>
                        <div style="margin-top:25px">
                                <a-tag color="#2db7f5">{{task.Processing}}</a-tag>
                        </div>
                    </a-col>
                    <a-col :span="4" style="border-right:rgba(0, 0, 0, 0.06) 1px solid">
                        <div class="miaoshu">
                            已完成
                        </div>
                        <div style="margin-top:25px">
                                <a-tag color="#67C23A">{{task.Completed}}</a-tag>
                        </div>
                    </a-col>
                    <a-col :span="4">
                        <div class="miaoshu">
                            已完成 / 总单数
                        </div>
                        <div style="margin-top:20px">
                             <a-progress style="width:80%" :percent="task.Percent" size="small" status="active" />
                        </div>
                    </a-col>
                </a-row>    
            </a-card>

            <a-row style="margin-top:20px"> 


                <a-col :span="24" style="padding-right:10px">
                        <a-table @expand="expandRow" :columns="columns" :rowKey="record => record.Id"  :data-source="task.TaskList" :pagination="false">
                                    <template #expandedRowRender="{ record }">
                                        <a-list v-if="record.Details" item-layout="horizontal" :data-source="record.Details">
                                            <template #renderItem="{ item }">
                                                <a-list-item> 
                                                    <a-list-item-meta>
                                                        <template #description>
                                                            <a-row :gutter="20" style="margin-top:5px">
                                                                <a-col :span="6">
                                                                    {{item.Spec}}
                                                                </a-col>
                                                                <a-col :span="6">
                                                                    {{item.KeyWords}}
                                                                </a-col>
                                                                <a-col :span="4">
                                                                    <a-tag class="tagbtn" @click="editNum(item)" color="#409EFF">{{item.Num}}</a-tag>
                                                                </a-col>
                                                                <a-col :span="4">
                                                                    <a-tag class="tagbtn" @click="showOrder(false,item)" color="#2db7f5">{{item.ProcessNum}}</a-tag>
                                                                </a-col>
                                                                <a-col :span="4">
                                                                    <a-tag class="tagbtn" @click="showOrder(true,item)" color="#67C23A">{{item.OkNum}}</a-tag>
                                                                </a-col>
                                                            </a-row>
                                                        </template>
                                                        <template #title>
                                                            <a-row :gutter="20">
                                                                <a-col :span="12">
                                                                    {{item.Title}}
                                                                </a-col>
                                                                <a-col :span="4">
                                                                    <span style="color:rgba(0,0,0,.45)">发布单数(点击增减)</span>
                                                                </a-col>
                                                                <a-col :span="4">
                                                                    <span style="color:rgba(0,0,0,.45)">进行中(点击查看)</span>
                                                                </a-col>
                                                                <a-col :span="4">
                                                                    <span style="color:rgba(0,0,0,.45)">已完成(点击查看)</span>
                                                                </a-col>
                                                            </a-row>
                                                        </template>
                                                    </a-list-item-meta>
                                                </a-list-item>
                                            </template>
                                        </a-list>
                                    </template>
                                    <template #code="{ text }">
                                        <a>
                                            {{text}}
                                        </a>
                                    </template>
                                    <template #hour="{ record }">
                                        <a-tag color="#f082ac">{{record.StartHour}}-{{record.EndHour}}</a-tag>
                                    </template>

                                    <template #total="{ text }">
                                        <a-tag color="#409EFF">{{text}}</a-tag>
                                    </template>
                                    <template #processNum="{ text }">
                                        <a-tag color="#2db7f5">{{text}}</a-tag>
                                    </template>
                                    <template #okNum="{ text }">
                                        <a-tag color="#67C23A">{{text}}</a-tag>
                                    </template>
                                    <template #autoType="{ text,record }">
                                            <a-tooltip placement="top" v-if="text==0">
                                                <template #title>
                                                    <div>按照单量均匀派出任务</div>
                                                    <div>点击切换为尽力交付模式</div>
                                                </template>
                                                <a @click="changeType(record,1)"><QuestionCircleOutlined /> 均匀打散</a>
                                            </a-tooltip>
                                            <a-tooltip placement="top" v-else>
                                                <template #title>
                                                    <div>满足任务条件的买手出现马上派出</div>
                                                    <div>点击切换为均匀打散模式</div>
                                                </template>
                                                <a @click="changeType(record,0)"><QuestionCircleOutlined /> 尽力交付</a>
                                            </a-tooltip>
                                    </template>
                                    <template #isPause="{ text,record }">
                                        <a-button @click="changePause(record)" type="primary" shape="round"  v-if="text">
                                            <template #icon>
                                                <PlayCircleOutlined /> 继续
                                            </template>
                                        </a-button>
                                        <a-button  @click="changePause(record)"  shape="round"  v-else>
                                            <template #icon>
                                                <PauseCircleOutlined /> 暂停
                                            </template>
                                        </a-button>
                                    </template>
                                     <template #nextTime="{ record,index }">
                                        <a-time-picker style="width:100px" :disabledHours="getDisabledHours" :disabledMinutes="getDisabledMinutes" :disabledSeconds="getDisabledSeconds"
                                            placeholder="请选择" v-model:open="timeList[index].nextOpen" format="HH:mm"  @openChange="(e) => openChangeNext(e, record,index)" v-model:value="timeList[index].nextTime">
                                            <template #addon>
                                                <a-button size="small" style="margin:5px;width:85px" type="primary" @click="setTime(1,record,index)">确定</a-button>
                                            </template>
                                        </a-time-picker>
                                    </template>
                                    <template #endTime="{ record,index }">
                                        <a-time-picker  style="width:100px" :disabledHours="getDisabledHours" :disabledMinutes="getDisabledMinutes" :disabledSeconds="getDisabledSeconds"
                                            placeholder="请选择" v-model:open="timeList[index].endOpen"  format="HH:mm"  @openChange="(e) => openChangeEnd(e, record,index)" v-model:value="timeList[index].endTime">
                                            <template #addon>
                                                <a-button size="small" style="margin:5px;width:85px" type="primary" @click="setTime(2,record,index)">确定</a-button>
                                            </template>
                                        </a-time-picker>
                                    </template>
                                    <template #shopName="{ text,record }">
                                        <div style="height:46px">
                                            <div  style="width:200px;line-height:46px;flot:left;vertical-align:middle; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                                    <svg style="vertical-align:middle"  width="40" height="40" v-if="record.ShopType==1" t="1624775837237"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9375"><path d="M376.3 296.6c29.1-49.5 39.8-99 39.8-99l84.2 34-24.5 48s6.1 6.2 27.5 3.1 162.2-74.3 258.6-57.2c97.7 17.3 157.6 94.4 157.6 154.7v289.3s-10.7 88.2-85.7 119.1c-75 30.9-189.7 7.7-189.7 7.7l6.1-48s68.9 15.5 111.7 1.5c42.8-13.9 55.1-48 55.1-48v-345s-6.1-35.6-45.9-60.3c-39.8-24.8-59.7-21.7-102.5-15.5-42.8 6.2-108.6 37.1-108.6 37.1l-36.7 72.7h247.9v49.5H619.6v61.9h157.6v43.3l-154.5 6.2v117.6l73.5-32.5-6.1-51.1 59.7-12.4 44.4 117.6-73.5 34-9.2-41.8s-138.9 59.2-194.6 63.8c-55.7 4.6-110.4-8.8-137-46.9-26.5-38.1-20.3-114.4-20.3-114.4l99 2.5s-7.7 43.5 11.8 71S534 680 534 680V548.8l-153-4.6v-41.8h154.5l-1.5-61.9-47.4-9.3s-39.8 61.9-65.8 60.3c-26-1.5-29.1-37.1-29.1-37.1l84.2-105.2-45.9-4.6-68.9 82-52-46.4c-0.1-0.1 38.2-34.1 67.2-83.6z m-175.9 64.9l-52 74.3s111.7 55.7 120.9 100.6c9.2 44.9-153 179.5-153 179.5l115.7 85s119.8-212 110.7-281.6-142.3-157.8-142.3-157.8z m62.3-31.5c37.8 0 68.4-31 68.4-69.1 0-38.2-30.6-69.1-68.4-69.1-37.8 0-68.4 31-68.4 69.1 0 38.2 30.6 69.1 68.4 69.1z" fill="#d81e06" p-id="9376"></path></svg>
                                                    <svg style="vertical-align:middle"  width="40" height="40"    v-else-if="record.ShopType==2" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8657"><path d="M178.9 377.2c1.6 21.1 4 42.4 4.8 63.6 1.5 39.5-14.1 70.9-46.2 93.9-24.7 17.7-51.8 30.6-81.4 37.6-34.6 8.1-63.4-20.3-54.4-54.7C6.8 498 13.4 478 23.6 460.7c25.4-42.8 41-89.2 53.7-136.8 2.3-8.9 5.5-17.7 9.5-26 6.9-14.4 22.6-21.8 37.7-17.3 10.9 3.3 21.5 7.9 31.6 13.3 16.1 8.4 31.8 18 47.6 27.1 9.7-10.4 19-21.4 29.1-31.4 35.4-35.1 79-57.4 123.5-78 69.7-32.2 141.4-59.5 216.8-75.2 34.9-7.2 70.6-11.9 106.2-14.6 42.5-3.2 85.2-4.8 127.7-3.7 55.2 1.3 109.6 8.6 160 34 27.2 13.7 50 32.6 54.9 63.6 3.4 21.7 2.1 44.7-0.4 66.8-4.1 37.5-19.4 72-34.3 106.1-4 9-14.4 16.2-23.3 21.5-22.8 13.3-48.2 20.2-74 25.1-72.7 13.9-144.1 7.7-213.6-17.3-41.3-14.8-74.6-41.8-104.9-72.7-3.2-3.2-5.7-7.5-9.6-9.3-4.1-2-10.6-3.6-13.5-1.6-3 2.1-4.8 9-4 13.1 1.1 4.9 4.8 9.8 8.4 13.7 44 47.6 97.6 79.5 160.7 94.1 75.4 17.4 150.5 16.5 224.5-8.1 4.2-1.4 8.4-3 12.5-4.9 4-1.8 7.9-4 13.4-4.9-8.2 11.9-15.9 24-24.4 35.6-57.4 77-131.1 131.2-224 158.3-59.3 17.3-118.6 14.8-177.6 0.5-98.5-24-189-65.4-267-131.4-24.3-20.5-47.2-42.7-63.2-70.6-6.2-10.7-11.4-22.4-14.4-34.2-2.3-9.7-6.2-15.8-14.3-18.3z m717.2-235.3c-11.4 1.1-23 1.5-34.3 3.3-17.5 2.8-34.2 8.5-48.1 20-12.3 10-10.9 24.5 2.8 32.2 5.5 3 11.7 5.3 17.7 6.9 27.7 7.6 55.9 5.6 83.9 2.5 14.4-1.6 28.6-6.2 42.1-11.4 9.3-3.6 16.3-11.6 15.9-23-0.5-10.9-9.3-14.8-17.3-18.6-19.7-9.2-41-11.8-62.7-11.9zM567.3 269.7c16.6 0 29.5-11.7 29.5-26.4-0.1-14.6-13.7-26.7-29.7-26.6-16.7 0.1-29.2 11.6-29.3 26.6 0 14.7 12.9 26.3 29.5 26.4z m128.5 635.9c-7.7 0-15.1 0.5-22.3-0.2-2-0.2-4.7-3.6-5.3-6.1-5.4-21-9.9-42.4-15.8-63.3-2.2-8.2-6.4-16.1-11.2-23.2-7.2-10.9-19.4-12.3-27.5-2.1-7.9 9.8-14.9 20.9-19.8 32.6-7.1 17-12.3 34.9-17.3 52.8-2.1 7.4-4.7 11.2-12.8 9.9-4.6-0.7-9.5-0.1-15.2-0.1 1.2-30.6 2.2-60.2 3.4-92.6-7.2 3.6-12.7 5.4-16.9 8.6-9.7 7.8-19.3 15.9-28 24.7-15.9 16.2-31.3 33-46.7 49.8-9.7 10.5-13.1 11.6-29.8 7.7 19.7-33.5 39.3-66.7 59.5-100.6-19.4-5.6-36.3-13.3-43.5-33.2-4.6-12.4-3.9-24.6 1.2-37.4 1.2 4.3 2.1 8.8 3.4 13.1 6.5 22.3 26.1 33.9 48.2 27.2 5.7-1.8 12-6.5 15.2-11.6 19.4-31.3 38.1-63 56.5-94.8 3.4-5.8 6.8-6.9 13.1-5.8 30.4 4.8 60.8 9.3 91.4 1.3 6.7-1.8 13.1-4.6 20.2-7.1v250.4z" p-id="8658" fill="#d81e06"></path></svg>
                                                    <svg style="vertical-align:middle"  width="40" height="40"    v-else-if="record.ShopType==3" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8132"><path d="M204.8 81.2c10.3-9 21.4-17 33.2-24.1v343.3c-51.2-36.1-99.3-75.3-150.5-111.5-30.1-21.1-57.2-42.1-87.3-63.2C69.4 177.6 135.8 129.3 205 81.2h-0.2z m-69.2 81.3c0 9.1-3.1 15.1-3.1 24.1-3.1 9.1 9.1 21.1 0 30.1-6 15.1-12 27.1-18 39.2-3.3 4.5-3.3 10.6 0 15.1 3.1 6 12 3.1 18 3.1 6 3.1 9.1 6 15.1 6s9.1-3.1 15.1-3.1 12 3.1 15.1 0c3.1 0 6-3.1 12-6h15c6-3.1 6-12 3.1-18-9.7-9.7-17.8-20.9-24.1-33.2-9.1-12 6-27.1 0-39.2-3.1-3.1-3.1-12-3.1-18h-6c-2.5 7.8-7.9 14.3-15.1 18-7.8-2.5-14.3-7.9-18-15.1 0-3.1-3.1-3.1-6-3.1v0.1zM256 57.2c30.1 21.1 60.3 42.1 93.3 63.2l153.6 108.4c-5.6 3.2-10.7 7.3-15.1 12-75.3 51.2-150.5 105.5-228.9 156.7C256 286 256 171.6 256 57.2z m24.1 129.5c3.3 7.4 7.4 14.5 12 21.1 3.1 0 6-3.1 9.1-3.1V277c27 3 54.3 3 81.3 0 1.5-24.1 1.5-48.2 0-72.3 3.1 0 6 3.1 9.1 3.1 6.7-6.8 11.9-15 15.1-24.1-15.1-3.1-30.1-12-45.2-15.1-3.2 9-11.6 15-21.1 15.1-9.1 0-15.1-9.1-18-15.1-14.8 4.2-28.9 10.2-42.1 18l-0.2 0.1zM521 231.9c81.4-60.3 165.8-117.5 247-174.7v340.4C686.7 343.2 602.4 286 521.1 231.9h-0.1z m132.4-69.3c-4.5 14.7-4.5 30.5 0 45.2 6 15.1 21.1 24.1 30.1 36.1 6 6 3.1 15.1 3.1 21.1-8.6 2.8-16.7 6.8-24.1 12h54.3c-9.1-3.1-15.1-9.1-24.1-12 0-6-3.1-18 3.1-21.1 13.1-9.1 23.5-21.6 30.1-36.1 6-15.1 0-30.1-3.1-45.2h-69.4zM783.1 57.2l63.2 45.2c51.2 36.1 99.3 69.2 150.5 105.5l27.1 18C942.6 283.1 864.3 340.3 783 400.6V57.2z m45.2 93.3c2.6 11.1 10.5 20.1 21.1 24.1h18c-3.1-6-3.1-15.1-9.1-18-9-9.2-21.1-6.1-30-6.1z m48.1 9.1c-3.7 4.6-6.7 9.7-9.1 15.1 6 0 15.1 0 18-3.1 3.7-4.6 6.8-9.7 9.1-15.1-6.1-0.5-12.3 0.6-18 3.1z m-18 21.1c-27.9 4.5-46.9 30.8-42.4 58.7 0.1 0.5 0.2 1.1 0.3 1.6 4.1 26.1 27.8 44.5 54.1 42.1 13.8-1.6 26.5-8 36.1-18 11.9-15.4 15.3-35.8 9.1-54.3-11-21-33.8-33-57.2-30.1z m-66.3 234.9c78.3-57.2 153.6-111.5 231.9-168.7v340.4C945.7 530 870.4 475.7 792.1 418.5c0 0-3.1-3.1 0-3.1v0.2z m123.5-33.2c-19.8 2.5-36.8 15.1-45.2 33.2-3.1 12 9.1 18 15.1 27.1 9.4 8 20.9 13.2 33.2 15.1 8.6 6.7 17.6 12.7 27.1 18 2.5-7.8 3.5-15.9 3.1-24.1 10.5-6.3 20.6-13.4 30.1-21.1 9.1 3.1 15.1 12 21.1 15.1 3.1 0 9.1 0 9.1-3.1-0.6-7.4-2.6-14.5-6-21.1 3.8-6.4 5.8-13.7 6-21.1 0-6-6-9.1-12-6-6.4 3.4-11.7 8.7-15.1 15.1-12-6-21.1-15.1-33.2-21.1v-24.1c-15.1 0-24.1 12-33.2 18l-0.1 0.1zM0 249.9c78.3 57.2 153.6 111.5 231.9 168.7 3.1 0 0 3.1 0 3.1C153.6 475.8 78.3 533.1 0 587.2V249.9z m69.2 117.5c-2.3 5.4-5.4 10.5-9.1 15.1-2.9 3.7-7.3 5.9-12 6-8.1 6.6-12.6 16.6-12 27-3 9.8-3 20.3 0 30.1 0.9 9.1 8.9 15.8 18 15.1h69.2c5.6-0.1 11-2.2 15.1-6 6-6 3.1-18 3.1-27.1-1.2-12.4-4.3-24.6-9.1-36.1-6.2-3.7-12.3-7.7-18-12-2.8-10.3-10.8-18.4-21.1-21.1-8.8 0.2-17.2 3.4-24.1 9z m349.4-21.1c12-15.1 15.1-33.2 24.1-48.1 8.3 14.5 15.3 29.6 21.1 45.2 6 0 12 3.1 21.1 3.1v17.9c9.1-3.1 18-3.1 30.1-6-6-21.1-15.1-42.1-21.1-60.3 21.1 9.1 39.2 15.1 57.2 24.1-6 12-9.1 27.1-15.1 42.1 9.1-3.1 18-3.1 24.1-6 3.1 0 3.1-3.1 6-6 8.3-17.6 15.4-35.7 21.1-54.3 15.1 9.1 27.1 21.1 42.1 30.1l-9.1 9.1c-9.1 9.1-21.1 15.1-30.1 24.1h39.2c3.1 9.1 6 21.1 9.1 30.1h-23.9c-3.1 12-6 24.1-9.1 39.2 11.4 1.6 22.5 4.7 33.2 9.1 5.8 9.2 9.9 19.4 12 30.1-12 3.1-27.1 3.1-39.2 6l-9.1 63.2c-6.3 6-13.4 11.1-21.1 15.1-6-27.1-9.1-54.3-15.1-81.3-9.2 0.5-18.3-0.6-27.1-3.1-6 21.1-9.1 45.2-15.1 66.3-6 9.1-15.1 9.1-24.1 15.1 0.5-26.1-0.5-52.3-3.1-78.3-6.2 0.4-12.4-0.6-18-3.1-3.1-9.1-6-15.1-9.1-24.1-12 12-9.1 30.1-12 45.2-3.1 21.1-6 42.1-9.1 60.3-16.8-11.1-32.8-23.1-48.1-36.1 9.1-3.1 21.1-6 30.1-9.1-3.1-15.1-3.1-30.1-6-45.2-6 3.1-12 9.1-18 12-6-15.1-9.1-33.2-15.1-48.1 11.3-0.3 22.5-2.3 33.2-6 0-12-3.1-21.1-3.1-33.2-3.1 0-6-3.1-9.1-3.1-6.7-9.6-12.7-19.7-18-30.1 8.4-0.2 16.6-2.3 24.1-6l0.1 0.1z m39.1 75.3h30.1l-9.1 18 27.1-9.1c-3.1-9.1-3.1-21.1-6-30.1-6-3.1-12-3.1-18-6-6-6-6-12-9.1-18-12 9.1-12 27.1-15.1 45.2h0.1z m87.3-24.1c-3.1 12-3.1 24.1-6 36.1 12-3.1 21.1-3.1 33.2-6 0-12-3.1-24.1-3.1-33.2-8.2-0.4-16.3 0.6-24.1 3.1zM84.2 367.4c9.1-3.1 18 6 21.1 15.1H69.2c6-6 9.1-12 15.1-15.1h-0.1z m448.9 240.9L768 436.7V780l-72.3-54.3c-54.3-39.2-108.4-81.3-162.7-117.5l0.1 0.1z m141.6-69.2c-3.1 6-3.1 15.1-6 21.1 6-3.1 12-3.1 18-6 10.4-2.4 21.4-0.2 30.1 6-3.1-6-3.1-15.1-6-21.1h-36.1z m6 27.1c-12.2 3.6-22.1 12.4-27.1 24.1-4.8 17.4 2.6 35.9 18 45.2 14.7 8.6 33.3 6.1 45.2-6 15.1-12.7 17.1-35.2 4.4-50.3-3.6-4.4-8.3-7.8-13.5-10-9.1-6-18-3.1-27.1-3.1l0.1 0.1z m-12 78.3c3.1 6 3.1 15.1 6 21.1h33.2c2.4-6.9 4.4-14 6-21.1-12.1 9.1-30.1 6.1-45.2 0z m114.4-210.8c81.3 57.1 159.6 111.4 240.9 168.6l-126.5 90.4C861.4 719.8 822.2 747 786 774c-3-111.5-3-226-3-340.4l0.1 0.1z m78.3 96.4v24.1h9c3.1-6 0-9.1 0-15.1 6-9.1-6-6-9.1-9.1l0.1 0.1z m-33.1 3.1v21.1c3.1 0 6 3.1 9.1 3.1-3.1-9.1 6-24.1-9.1-24.1v-0.1z m69.2 0c-3.1 6 0 12 0 18 0 3.1 9.1 3.1 9.1 0 3.1-6 0-12 0-18h-9.1z m-78.3 32.9v87.3c0 3.1 6 6 9.1 6h69.2c6 0 12 3.1 15.1-3.1 2.5-5.7 3.5-11.9 3.1-18 6-3.1 9.1-3.1 15.1-6 9.5-6.9 12.1-20 6-30.1-6-7.7-14.5-13.1-24.1-15.1v-21h-93.5zM0 602.3C78.3 548 156.7 490.8 238 436.7V777c-48.1-33.2-93.3-69.2-141.6-105.5-33.2-24-66.3-45.1-96.4-69.2z m198.8-57.2c-6 9.1-15.1 15.1-18 24.1-9.1 15.1-12 33.2-24.1 48.1-18 6-42.1 6-57.2 24.1 17.6 12.2 39.9 15.5 60.3 9.1 12-3.1 15.1-15.1 18-24.1 1.3-11.5 6.6-22.2 15.1-30.1 3.1-3.1 6 3.1 6 6v51.2h5.9c0-18-3.1-39.2 6-57.2 5.1-9.1 7.2-19.7 6-30.1-3.4-8.9-9.8-16.3-18-21.1zM256 436.7c48.1 33.2 93.3 66.3 138.5 102.4 30.1 24.1 63.2 45.2 93.3 69.2C409.6 665.5 331.3 722.8 256 780V436.7z m66.3 111.5c-6 3.1-6 9.1-12 12-8.1-0.5-16.3 0.6-24.1 3.1-3.1 0-6 6-6 9.1v69.2c0 6 9.1 6 12 6h99.3c6 0 6-6 6-12v-69.5c-8.2-4.8-17.7-6.9-27.1-6-3.6-5.6-8.9-9.8-15.1-12l-33 0.1zM265.1 792c81.3-57.2 159.6-114.4 240.9-168.7V804c3.1 54.3 0 108.4 0 159.6-57.2-39.2-111.5-81.3-168.7-120.4-24.1-18-51.2-36.1-72.3-51.2h0.1z m150.5-66.3h12c-3.1-3.1-3.1-6-6-6l-6 6z m-42.1 27.1c-7.8 11.1-13.9 23.2-18 36.1 3.1 0 9.1-3.1 12-3.1 9.1 0 18 3.1 24.1 0 6.7-3 14.4-3 21.1 0 0.5 16.2-0.5 32.4-3.1 48.4 0 6-9.1 6-12 6l-9.1-18c-3.1 3.1-6 3.1-6 6-1.3 10.6 5 20.6 15.1 24.1 11.3 3.5 23.4-2.9 26.9-14.2l0.3-0.9V786c9.1-2 18.7-0.9 27.1 3.1 10.8-3 22.3-3 33.2 0-1.9-12.2-7.1-23.7-15.1-33.2-5.7-6.7-13-11.9-21.1-15.1-24.2-17.5-57.9-12.1-75.4 12z m147.6-129.4c81.3 57.2 159.6 111.5 240.9 168.7-78.3 57.2-159.6 117.5-238 174.7-3-117.5-3-231.9-3-343.2l0.1-0.2z m78.3 96.4c-3.1 3.1-3.1 9.1-9.1 9.1-9.1 6-18 15.1-27.1 21.1 3.5 2.4 7.8 3.5 12 3.1h66.3c-6-9.1-15.1-12-21.1-18-9.1-6-15.1-12-21.1-15.1l0.1-0.2z m-36.2 45.1v63.2c0 3.1 0 9.1 6 9.1h69.2c2.5-8.8 3.5-18 3.1-27.1v-45.2c0-3.1-6-3.1-9.1-3.1-23.1-0.6-46.2 0.4-69.2 3.1z" p-id="8133" fill="#d81e06"></path></svg>
                                                    <svg style="vertical-align:middle"  width="40" height="40" v-else-if="record.ShopType==5" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7433" ><path d="M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2 0.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-0.5 0.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9z m85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-0.1-6.8-1.4-13.3-4.1-19.1z" p-id="7434" fill="#d81e06"></path></svg>
                                                    <svg style="vertical-align:middle"  width="40" height="40"  v-else class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1814" ><path d="M937.4 423.9c-84 0-165.7-27.3-232.9-77.8v352.3c0 179.9-138.6 325.6-309.6 325.6S85.3 878.3 85.3 698.4c0-179.9 138.6-325.6 309.6-325.6 17.1 0 33.7 1.5 49.9 4.3v186.6c-15.5-6.1-32-9.2-48.6-9.2-76.3 0-138.2 65-138.2 145.3 0 80.2 61.9 145.3 138.2 145.3 76.2 0 138.1-65.1 138.1-145.3V0H707c0 134.5 103.7 243.5 231.6 243.5v180.3l-1.2 0.1" p-id="1815" fill="#d81e06"></path></svg>
                                                    <span style="vertical-align:middle;margin-left:5px">{{text}}</span>
                                            </div>
                                        </div>
                                    </template>
                        </a-table>
                </a-col>
            </a-row>
        </div>
        </a-spin>
        <myFooter/>
        <a-modal v-model:visible="editNumVisible" title="调整发布单数">
            <a-descriptions :column="2" :title="setDetailRow.Title">
                <a-descriptions-item label="关键字">{{setDetailRow.KeyWords}}</a-descriptions-item>
                <a-descriptions-item label="规格">{{setDetailRow.Spec}}</a-descriptions-item>
                <a-descriptions-item label="进行中">
                    <a-tag color="#2db7f5">{{setDetailRow.ProcessNum}}</a-tag>
                </a-descriptions-item>
                <a-descriptions-item label="已完成">
                    <a-tag color="#67C23A">{{setDetailRow.OkNum}}</a-tag>
                </a-descriptions-item>
                <a-descriptions-item label="发布单数">
                    <a-button @click="changeEditNum(-1)" style="margin-left:5px" shape="round" size="small">
                        <template #icon>
                            -1
                        </template>
                    </a-button>
                    <a-button @click="changeEditNum(-5)" style="margin-left:5px" shape="round" size="small">
                        <template #icon>
                            -5
                        </template>
                    </a-button>
                    <a-button @click="changeEditNum(-10)" style="margin-left:5px" shape="round" size="small">
                        <template #icon>
                            -10
                        </template>
                    </a-button>
                    <a-tag style="margin-left:13px"  color="#409EFF">{{editNumValue}}</a-tag>
                    <a-button @click="changeEditNum(+1)" style="margin-left:5px" shape="round" size="small">
                        <template #icon>
                            +1
                        </template>
                    </a-button>
                    <a-button @click="changeEditNum(+5)" style="margin-left:5px" shape="round" size="small">
                        <template #icon>
                            +5
                        </template>
                    </a-button>
                    <a-button @click="changeEditNum(+10)" style="margin-left:5px" shape="round" size="small">
                        <template #icon>
                            +10
                        </template>
                    </a-button>
                </a-descriptions-item>
            </a-descriptions>

            <template #footer>
                <a-button @click="editNumVisible=false">取消</a-button>
                <a-button  type="primary" @click="editNumSumbit">确定</a-button>
            </template>
        </a-modal>

        <a-drawer
        style="padding:0px"
            height="60%"
            placement="bottom"
            :closable="false"
            :visible="orderVisible"
            @close="orderVisible=false"
        >
            <a-table 
            style="margin-top:-24px"
                :rowKey="record => record.Id" 
                :columns="orderColumns"  
                :pagination="false"
                :loading="loadingOrder"
                :data-source="orderList">
                    <template #orderCode="{text}">
                        <a> {{text}}</a>
                    </template>
                    <template #aliTrademanager="{text}">
                        <a> {{text}}</a>
                    </template>
                    <template #advanceMoneyText="{ text }">
                        <span style="font-weight:500">
                            {{text}}
                        </span>
                    </template>
                    <template #actualCommissionText="{ text }">
                        <span style="font-weight:500">
                            {{text}}
                        </span>
                    </template>
                    <template #status="{ text }">
                        <a-tag color="#409EFF" v-if="text==0">待确认</a-tag>
                        <a-tag color="#409EFF" v-else-if="text==1">搜索</a-tag>
                        <a-tag color="#409EFF" v-else-if="text==2">货比</a-tag>
                        <a-tag color="#409EFF" v-else-if="text==3">找商品</a-tag>
                        <a-tag color="#409EFF" v-else-if="text==4">浏览商品</a-tag>
                        <a-tag color="#409EFF" v-else-if="text==5">关注店铺</a-tag>
                        <a-tag color="#409EFF" v-else-if="text==6">付款</a-tag>
                        <a-tag color="#409EFF" v-else-if="text==9">提交任务</a-tag>
                        <a-tag color="#409EFF" v-else-if="text==10">待审核</a-tag>
                        <a-tag color="#67C23A" v-else>已完成</a-tag>
                    </template>
            </a-table>
        </a-drawer>
    </div>    
</template>

<script>
 
import myHead from '../components/myHead'
import myFooter from '../components/myFooter'
import { QuestionCircleOutlined,PlayCircleOutlined,PauseCircleOutlined,ExclamationCircleOutlined} from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
import { createVNode, } from 'vue';

import { taskGetConsole,taskSetTime,taskChangeIsPause,taskChangeType,taskGetDetailConsole,taskEditDetailNum,taskGetOrderByDetailId} from '@/request.js'

export default {
        components:{myHead,myFooter,QuestionCircleOutlined,PlayCircleOutlined,PauseCircleOutlined},

    data(){
        return {
            loadingOrder:false,
            orderList:[],
            orderVisible:false,
            modalTitle:'',
            editNumValue:0,
            editNumVisible:false,
            timeList:[],
            startTime:"",
            isLoading:false,
            task:{},
            columns:[
                {
                    title: '任务编号',
                    dataIndex: 'Code',
                    key: 'Code',
                    slots: { customRender: 'code' },
                },
                {
                    title: '所属店铺',
                    dataIndex: 'ShopName',
                    key: 'ShopName',
                    slots: { customRender: 'shopName' },
                },
                // {
                //     title: '开始-结束',
                //     key: 'Hour',
                //     slots: { customRender: 'hour' },
                // },
                {
                    title: '总单数',
                    dataIndex: 'Total',
                    key: 'Total',
                    slots: { customRender: 'total' },
                },
                {
                    title: '进行中',
                    dataIndex: 'ProcessNum',
                    key: 'ProcessNum',
                    slots: { customRender: 'processNum' },
                },
                {
                    title: '已完成',
                    dataIndex: 'OkNum',
                    key: 'OkNum',
                    slots: { customRender: 'okNum' },
                },
                {
                    title: '放单模式',
                    dataIndex: 'AutoType',
                    key: 'AutoType',
                    slots: { customRender: 'autoType' },
                },
                {
                    title: '下次放单',
                    dataIndex: 'NextTime',
                    key: 'NextTime',
                    slots: { customRender: 'nextTime' },
                },
                {
                    title: '结束时间',
                    dataIndex: 'EndTime',
                    key: 'EndTime',
                    slots: { customRender: 'endTime' },
                },
                {
                    title: '操作',
                    dataIndex: 'IsPause',
                    key: 'IsPause',
                    slots: { customRender: 'isPause' },
                },
            ],
            orderColumns:[
                {
                    title: '订单编号',
                    dataIndex: 'OrderCode',
                    key: 'OrderCode',
                    slots: { customRender: 'orderCode' },
                },
                {
                    title: '阿里旺旺',
                    dataIndex: 'AliTrademanager',
                    key: 'AliTrademanager',
                    slots: { customRender: 'aliTrademanager' },
                },
                {
                    title: '垫付本金',
                    dataIndex: 'AdvanceMoneyText',
                    key: 'AdvanceMoneyText',
                    slots: { customRender: 'advanceMoneyText' },
                },
                {
                    title: '实际佣金',
                    dataIndex: 'ActualCommissionText',
                    key: 'ActualCommissionText',
                    slots: { customRender: 'actualCommissionText' },
                },
                {
                    title: '状态',
                    dataIndex: 'Status',
                    key: 'Status',
                    slots: { customRender: 'status' },
                },
            ],
            setDetailRow:{},
        }
    },
    created(){
        this.startTime=this.format(new Date(),"hh:mm:ss")
    },
    methods: {
        showOrder(isComplete,record){
            if((isComplete&&record.OkNum==0)||(!isComplete&&record.ProcessNum==0)){
                return;
            }
            this.loadingOrder=true;
            taskGetOrderByDetailId({detailId:record.Id,isComplete:isComplete},(res)=>{
                this.loadingOrder=false;
                this.orderList=res.Result;
                if(this.orderList.length==0){
                    message.error("没有查询到订单数据，请刷新！");
                }else{
                    this.orderVisible=true;
                }
            });
        },
        editNumSumbit(){
            let val=this.editNumValue-this.setDetailRow.Num;
            taskEditDetailNum({detailId:this.setDetailRow.Id,val:val},(res)=>{
                if(res.IsSuccess){
                    this.setDetailRow.Num=this.editNumValue;
                    this.editNumVisible=false;
                    message.success("修改成功");
                }else{
                    message.error(res.Message); 
                }
            });
        },
        changeEditNum(value){
            if(this.editNumValue-this.setDetailRow.OkNum-this.setDetailRow.ProcessNum+value<0){
                message.error("不能再减啦~"); 
                return;
            }
            this.editNumValue+=value;
        },
        editNum(item){
            this.setDetailRow=item;
            this.editNumValue=this.setDetailRow.Num;
            this.editNumVisible=true;
        },
        expandRow(info,record){
            if(info){
                taskGetDetailConsole({taskId:record.Id},(res)=>{
                    record.Details=res.Result;
                });
            }
        },
        changePause(record){
            let type=record.IsPause?'继续':'暂停';
            Modal.confirm({
                title: '确定'+type+'任务吗?',
                icon: createVNode(ExclamationCircleOutlined),
                content: '',
                okText: '确定',
                okType: 'primary',
                cancelText: '取消',
                onOk() {
                    taskChangeIsPause({taskId:record.Id},(res)=>{
                        if(res.IsSuccess){
                            record.IsPause=!record.IsPause;
                            message.success("修改成功");
                        }else{
                            message.error(res.Message); 
                        }
                    })
                },
                onCancel() {
                    
                },
            });
        },
        changeType(record,type){
            let typeName=record.type==0?'均匀打散':'尽力交付';
            Modal.confirm({
                title: '确定切换为'+typeName+'放单模式吗?',
                icon: createVNode(ExclamationCircleOutlined),
                content: '',
                okText: '确定',
                okType: 'primary',
                cancelText: '取消',
                onOk() {
                    taskChangeType({taskId:record.Id,type:type},(res)=>{
                        if(res.IsSuccess){
                            record.AutoType=type;
                            message.success("修改成功");
                        }else{
                            message.error(res.Message); 
                        }
                    })
                },
                onCancel() {
                    
                },
            });

            
        },
        setTime(type,record,index){
            if(type==1){
                let time=this.format(new Date(this.timeList[index].nextTime),"yyyy-MM-dd hh:mm:ss");
                 taskSetTime({taskId:record.Id,time:time,setType:type},(res)=>{
                    if(res.IsSuccess){
                        record.NextTime=time;
                        this.timeList[index].nextOpen=false;
                        message.success("修改成功");
                    }else{
                        message.error(res.Message); 
                    }
                 })
            }else{
                let time=this.format(new Date(this.timeList[index].endTime),"yyyy-MM-dd hh:mm:ss");
                taskSetTime({taskId:record.Id,time:time,setType:type},(res)=>{
                    if(res.IsSuccess){
                        record.EndTime=time;
                        this.timeList[index].endOpen=false;
                        message.success("修改成功");
                    }else{
                        message.error(res.Message); 
                    }
                 })

                
            }
           
        },
        openChangeEnd(e,record,index){
            if(e){
                this.startTime=this.format(new Date(),"hh:mm:ss")
            }else{
                this.timeList[index].endTime=record.EndTime;
            }
        },
        openChangeNext(e,record,index){
            if(e){
                this.startTime=this.format(new Date(),"hh:mm:ss")
            }else{
                this.timeList[index].nextTime=record.NextTime;
            }
        },
        getDisabledHours () {
            let hours = []
            let time = this.startTime
            let timeArr = time.split(':')
            for (var i = 0; i < parseInt(timeArr[0]); i++) {
            hours.push(i)
            }
            return hours
        },
        getDisabledMinutes (selectedHour) {
            let time = this.startTime
            let timeArr = time.split(':')
            let minutes = []
            if (selectedHour == parseInt(timeArr[0])) {
            for(var i = 0; i < parseInt(timeArr[1]); i++) {
            minutes.push(i)
            }
            }
            return minutes
        },
        getDisabledSeconds (selectedHour, selectedMinute) {
            let time = this.startTime
            let timeArr = time.split(':')
            let second = []
            if (selectedHour == parseInt(timeArr[0]) && selectedMinute == parseInt(timeArr[1])) {
            for(var i = 0; i <= parseInt(timeArr[2]); i++) {
            second.push(i)
            }
            }
            return second
        },
        format (date,fmt) {
            let o = {
                "M+": date.getMonth() + 1,         //月份
                "d+": date.getDate(),          //日
                "h+": date.getHours(),          //小时
                "m+": date.getMinutes(),         //分
                "s+": date.getSeconds(),         //秒
                "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                "S": date.getMilliseconds()       //毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                }
            }
            return fmt;
        }
    },
    mounted(){
        this.isLoading=true,
        taskGetConsole({},(res)=>{
            for(var i=0;i<res.Result.TaskList.length;i++){
                this.timeList.push({
                    nextTime:res.Result.TaskList[i].NextTime,
                    endTime:res.Result.TaskList[i].EndTime,
                    nextOpen:false,
                    endOpen:false,
                })
            }
            this.task=res.Result;
            this.isLoading=false;
            // setInterval(() => {
            //     this.isLoading=true,
            //     taskGetConsole({},(res)=>{
            //         this.task=res.Result;
            //         this.isLoading=false;
            //     });
            // }, 5000);
        })
    }
}
</script>
<style scoped>
.miaoshu{
    color: rgba(0,0,0,.45)
}
.neirong{
    margin-top: 10px;
    color:rgba(0,0,0,.85);
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
}
.tagbtn{
    cursor: pointer;
}
</style>